import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export interface RichTextEditorProps {
    value?: string;
    placeholder?: string;
    tabCommand?: () => void;
    onChange?: (value: string) => void;
    onBlur?: (value: string) => void;
    readOnly?: boolean;
    hideTools?: boolean;
    hideBorder?: boolean;
}

export function RichTextEditor(props: RichTextEditorProps) {
    let [value, setValue] = useState<string | undefined>(props.value);
    let [focused, setFocused] = useState<boolean>(false);
    let modules = {
        toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
            ["link", "image"],
            ["clean"],
        ],
    };
    let modulesNoToolbar = {
        toolbar: false,
    };

    let formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
    ];

    let shouldHide = props.hideTools || props.readOnly;

    // if (shouldHide === undefined) shouldHide = false;
    //
    // if (shouldHide) {
    //     if (focused && !props.readOnly) shouldHide = false;
    // }

    return (
        <div>
            <ReactQuill
                placeholder={props.placeholder}
                readOnly={props.readOnly}
                value={value}
                onFocus={() => setFocused(true)}
                onBlur={() => {
                    setFocused(false);
                    if (props.onBlur) props.onBlur(value ?? "");
                }}
                onChange={(s) => {
                    setValue(s);
                    if (props.onChange) props.onChange(s);
                }}
                theme="snow"
                modules={shouldHide && !focused ? modulesNoToolbar : modules}
                formats={shouldHide && !focused ? [] : formats}
            ></ReactQuill>
        </div>
    );
}
